import React from 'react';
import { useAuthStore } from '../../lib/store-auth';
// import { ProfileAvatar } from '../profile/ProfileAvatar';

interface SidebarProps {
    onOpenProfile?: () => void;
    onOpenPastSessions?: () => void;
    activeTab?: 'simulations' | 'past-sessions' | 'leaderboard' | 'modules';
    onOpenSimulations?: () => void;
    onOpenLeaderboard?: () => void;
    onOpenModules?: () => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ onOpenProfile, onOpenPastSessions, activeTab = 'simulations', onOpenSimulations, onOpenLeaderboard, onOpenModules }) => {
    const { user } = useAuthStore();

    return (
        <aside className="dashboard-sidebar">
            {/* Logo Alanı */}
            <div className="sidebar-logo" style={{ position: 'relative' }}>
                {user?.institution_details?.logo_url ? (
                    <>
                        {/* Kurum Logosu - Ana Logo */}
                        <img
                            src={user.institution_details.logo_url}
                            alt={user.institution_details.name || 'Kurum'}
                            style={{
                                maxWidth: '220px',
                                maxHeight: '90px',
                                objectFit: 'contain'
                            }}
                        />
                        {/* Saletone - Sol Alt Küçük */}
                        <img
                            src="/logo.svg"
                            alt="Saletone"
                            style={{
                                position: 'absolute',
                                bottom: '8px',
                                left: '16px',
                                width: '80px',
                                opacity: 0.7
                            }}
                        />
                    </>
                ) : (
                    <img src="/logo.svg" alt="Saletone Logo" />
                )}
            </div>

            <nav className="sidebar-nav">
                <div
                    className={`nav-item ${activeTab === 'simulations' ? 'active' : ''}`}
                    onClick={onOpenSimulations}
                    style={{ cursor: 'pointer' }}
                >
                    <span className="material-symbols-outlined">dashboard</span>
                    Simülasyonlar
                </div>
                <div
                    className={`nav-item ${activeTab === 'modules' ? 'active' : ''}`}
                    onClick={onOpenModules}
                    style={{ cursor: 'pointer' }}
                >
                    <span className="material-symbols-outlined">school</span>
                    Modüller
                </div>
                <div
                    className={`nav-item ${activeTab === 'past-sessions' ? 'active' : ''}`}
                    onClick={onOpenPastSessions}
                    style={{ cursor: 'pointer' }}
                >
                    <span className="material-symbols-outlined">history</span>
                    Geçmiş Oturumlarım
                </div>
                <div
                    className={`nav-item ${activeTab === 'leaderboard' ? 'active' : ''}`}
                    onClick={onOpenLeaderboard}
                    style={{ cursor: 'pointer' }}
                >
                    <span className="material-symbols-outlined">leaderboard</span>
                    Liderlik Tablosu
                </div>
            </nav>


        </aside>
    );
};

